<template>
    <div>
        <a role="menuitem" tabindex="-1" @click="open = true"><i class="fa fa-fw fa-cube add-resource-icon"></i> {{ label }}</a>
        <modal v-model="open" @show="init" ref="modal" v-bind:id="modalId" title="Add resources" size="lg">
            <div class="row m-b">
                <div class="col-3">
                    <label>Resource type</label>
                    <select v-model="filters.type" class="form-control">
                        <option value="" selected>All types</option>
                        <option v-for="type in types" :value="type.id">{{ type.name_with_levels }}</option>
                    </select>
                </div>
                <div class="col-3">
                    <label>Supplier</label>
                    <select v-model="filters.supplier" class="form-control">
                        <option value="" selected>All suppliers</option>
                        <option v-for="supplier in suppliers" v-bind:value="supplier">{{ supplier }}</option>
                    </select>
                </div>
                <div class="col-5">
                    <label>Search</label>
                    <input v-model="filters.search" class="form-control">
                </div>
                <div class="col-1">
                    <label>&nbsp;</label>
                    <button v-on:click="setDefaultFilters" class="btn btn-block btn-warning"
                            data-toggle="tooltip" title="Reset filters"><i
                            class="fa fa-times fa-fw"></i></button>
                </div>
                <div class="col-12 m-t-md" v-if="allocatedResources.length">
                    <a href="#" v-on:click="displayAllocatedResources" v-if="!this.filters.allocated">View {{ allocatedResources.length }} selected resources</a>
                    <a href="#" v-on:click="setDefaultFilters" v-else>View all resources</a>
                </div>
            </div>
            <table class="table table-condensed">
                <thead>
                <tr>
                    <th>Type</th>
                    <th>Name</th>
                    <th>Supplier</th>
                    <th>Quantity</th>
                    <th class="text-right">Unit cost</th>
                    <th class="text-right">Total cost</th>
                    <th class="text-right">Unit price</th>
                    <th class="text-right">Total price</th>
                </tr>
                </thead>
                <tfoot v-if="allocatedResources.length">
                <tr>
                    <th colspan="2"></th>
                    <th>Total</th>
                    <th>{{ totalQuantity }}</th>
                    <th></th>
                    <th class="text-right">{{ totalCost }}</th>
                    <th></th>
                    <th class="text-right">{{ totalPrice }}</th>
                </tr>
                </tfoot>
                <tbody>
                <tr v-for="resource in filteredResources" v-bind:class="{ 'success': resource.allocated > 0 }">
                    <td>{{ resource.type }}</td>
                    <td><a v-bind:href="'/admin/crm/resources/' + resource.id" target="_blank"></a>{{
                        resource.name }}
                        <small v-if="resource.description"><br>{{ resource.description }}</small>
                    </td>
                    <td>{{ resource.supplier }}</td>
                    <td width="10%" class="text-right">
                        <input type="number"
                               v-model="resource.allocated"
                               class="form-control input-sm">
                    </td>
                    <td width="10%" class="text-right">
                        <input type="text"
                               v-model="resource.unit_cost"
                               class="form-control input-sm">
                    </td>
                    <td class="text-right">{{ lineTotalCost(resource) }}</td>
                    <td width="10%" class="text-right">
                        <input type="text"
                               v-model="resource.unit_price"
                               class="form-control input-sm">
                    </td>
                    <td class="text-right">{{ lineTotalPrice(resource) }}</td>
                </tr>
                </tbody>
            </table>
            {{ filteredResources.length }} resources found
            <span slot="footer">
                <button type="button" class="btn btn-default" @click="open = false">Close</button>
                <button class="btn btn-primary" v-on:click="saveResources">Save {{ allocatedResources.length }}
                    resources
                </button>
            </span>
        </modal>
    </div>
</template>

<script>
    export default {
        props: ['costid', 'types', 'suppliers', 'resourcetype', 'label'],
        data() {
            return {
                open: false,
                costId: this.costid,
                resources: [],
                filters: {},
            }
        },
        methods: {
            init() {
                this.setDefaultFilters();
                this.getResources();
            },
            setDefaultFilters: function () {
                this.filters = {
                    costId: this.costId,
                    search: '',
                    type: this.resourcetype,
                    supplier: '',
                    allocated: null,
                }
            },
            displayAllocatedResources() {
                this.setDefaultFilters();
                this.filters.allocated = true;
            },
            getResources: function () {
                window.axios.get('/api/crm/resources?cost_id=' + this.costId).then(({data}) => {
                    this.resources = data;
                });
            },
            saveResources: function () {
                window.axios.post('/api/crm/costs/' + this.costId + '/resources', {
                    resources: this.postData,
                    resource_type_id: this.filters.type
                }).then(({data}) => {
                    this.open = false;
                    window.toastr.success('Resources saved.');
                    location.reload();
                }).catch(({data}) => {
                    window.toastr.error('Resources could not be saved.')
                });
            },
            lineTotalCost: function (resource) {
                return this.lineTotal(resource.allocated, resource.unit_cost);
            },
            lineTotalPrice: function (resource) {
                return this.lineTotal(resource.allocated, resource.unit_price);
            },
            lineTotal: function(quantity, price) {
                return parseFloat(parseFloat(quantity) * parseFloat(price)).toFixed(2);
            }
        },
        computed: {
            selectedResourceType() {
                let types = this.types.filter(type => {
                    return parseInt(type.id) === parseInt(this.filters.type);
                });

                return types[0];
            },
            filteredResources() {
                return this.resources.filter(resource => {

                    if (!this.filters.search && !this.filters.type && !this.filters.supplier && !this.filters.allocated) {
                        return true;
                    }

                    if (this.filters.allocated === true) {
                        return resource.allocated > 0;
                    }

                    let typeMatch = this.filters.type ? (parseInt(this.selectedResourceType.id) === parseInt(resource.parent_type_id) || parseInt(resource.type_id) === parseInt(this.filters.type)) : true;
                    let supplierMatch = this.filters.supplier ? resource.supplier.toLowerCase().indexOf(this.filters.supplier.toLowerCase()) > -1 : true;
                    let searchMatch = false;

                    if (this.filters.search) {
                        let searchQuery = this.filters.search.toLowerCase();

                        let terms = searchQuery.split(' ');

                        let termsMatched = 0;

                        terms.forEach(function (term) {
                            if (resource.name.toLowerCase().indexOf(term) > -1 ||
                                resource.description.toLowerCase().indexOf(term) > -1 ||
                                resource.supplier.toLowerCase().indexOf(term) > -1 ||
                                resource.type.toLowerCase().indexOf(term) > -1) {
                                termsMatched++;
                            }
                        });

                        // If all terms have been matched somewhere in the record
                        searchMatch = termsMatched === terms.length;

                    } else {
                        searchMatch = true;
                    }

                    return typeMatch && searchMatch && supplierMatch;
                })
            },
            allocatedResources() {
                return this.resources.filter(resource => {
                    return resource.allocated > 0;
                });
            },
            totalPrice() {
                let total = 0;
                this.allocatedResources.forEach(function (resource) {
                    total = total + resource.allocated * resource.unit_price;
                });
                return parseFloat(total).toFixed(2);
            },
            totalCost() {
                let total = 0;
                this.allocatedResources.forEach(function (resource) {
                    total = total + resource.allocated * resource.unit_cost;
                });
                return parseFloat(total).toFixed(2);
            },
            totalQuantity() {
                let total = 0;
                this.allocatedResources.forEach(function (resource) {
                    total = total + parseFloat(resource.allocated);
                });
                return parseFloat(total).toFixed(2);
            },
            modalId() {
                return 'add-resource-modal-' + this.costId;
            },
            postData() {
                let data = [];
                let resources = this.allocatedResources;
                return resources;
                resources.forEach(function (resource) {
                    data[resource.id] = resource.allocated;
                });
                return data;
            }
        }
    }
</script>
